import React, {useEffect, useState} from "react";
import { useLocation, useParams } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { MdOutlineQrCode2 } from "react-icons/md";
import LabelOperacion from "./LabelOperacion";
import Comentarios from "./Comentarios";
import Documentos from "./Documentos";
import RegistroTiempos from "./RegistroTiempos";
import Contenedores from "./Contenedores";
import Demoras from "./Demoras"
import ModalEditSolicitud from "../../Home/components/ModalEditSolicitud";

import { getOneSolicitud } from "../../../../helpers/Api.js";
import BadgePills from "../../../../components/BadgePills";

const AdministradorOperacion = () => {

  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  let location = useLocation();
  const params = useParams();
  const [data, setData] = useState([]);
  const [query, setQuery] = useState(0);

    //Modals
  const [modalIsOpen, setIsOpen] = useState(false);
  const [idSolicitudEdit, setIdSolicitudEdit] = useState('');


  useEffect(() => {
    handlerGetOneSolicitud();
  }, [modalIsOpen, query]);


  const openModal = () => {
    setIsOpen(true);
    };
    const closeModal = () => {
    setIsOpen(false);
    };


  const handlerGetOneSolicitud = async () => {
    try {
      const response = await getOneSolicitud(params.id, token);
      if (response) {
        setData(response);
        setIdSolicitudEdit(response.id)
      }
    } catch (error) {
      throw error
    }
  };

  return (
        <div className="row">
        <div className="col-6 mb-5">
          <h6>Generales de referencia 
          {role !== 'NUS' && 
            <button onClick={openModal} className="btn" >
              <FiEdit className="mb-2" color={"#4516FF"}/>
            </button>
          }
          </h6>
          </div>
          <div className="col-6 d-flex flex-row-reverse mb-5 d-flex align-items-center">
            {(data.contenedores !== undefined && data.contenedores.length > 0) && <a
              className='btn btn btn-dark'
              href='#'  // Note: Set a dummy value for href
              onClick={(e) => {
                e.preventDefault(); // Prevent the default link behavior
                fetch(`${process.env.REACT_APP_API}/pdf-qr/${params.id}/`, {
                  headers: {
                    Authorization: `Token ${token}`,
                  }
                })
                  .then(response => response.blob())  // You might want to handle the response differently based on your needs
                  .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                  })
                  .catch(error => console.error('Error:', error));
              }}
              target='_blank'
              rel='noopener noreferrer'
            >
              <MdOutlineQrCode2 size={'1.4em'}/> Obtener QR 
            </a>}

            {/* <button className="btn btn btn-dark" >
              Obtener QR <MdOutlineQrCode2 size={'1.5em'} 
              style={{marginLeft: '6px',
              marginBottom: '4px'
              }} 
              color={"#FFFF"}/>
            </button> */}
          </div>
          <div className="col-12">
            <table className="table" style={{fontFamily: 'Inconsolata'}}>
              <thead>
                <tr>
                  <th scope="col">Concepto</th>
                  <th scope="col">Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Referencia</td>
                  <td>{data?.referencia}</td>
                </tr>
                <tr>
                  <td>Número de BL</td>
                  <td>{data?.numero_bl}</td>
                </tr>
                <tr>
                  <td>Cantidad de contenedores</td>
                  <td>{data?.cantidad_contenedores}</td>
                </tr>
                <tr>
                  <td>Patente</td>
                  <td>{data.agencia_aduanal?.patente}</td>
                </tr>
                <tr>
                  <td>Agencia Aduanal</td>
                  <td>{data.agencia_aduanal?.nombre}</td>
                </tr>
                <tr>
                  <td>Fecha de revalidación</td>
                  <td>{data?.fecha_revalidacion}</td>
                </tr>
                <tr>
                  <td>Fecha de atraque</td>
                  <td>{data?.fecha_eta}</td>
                </tr>
                <tr>
                  <td>Naviera</td>
                  <td>{data?.naviera_nombre}</td>
                </tr>
                <tr>
                  <td>Estado</td>
                  <td><BadgePills status={data.estado}/>
                  </td>
                </tr>
                <tr>
                  <td>Convenio de Colaboración</td>
                  <td>{data?.convenio_colaboracion === true ? 'Sí aplica' : 'No aplica'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        <div className="card_form mt-4">
          <LabelOperacion idSolicitud={data?.id} location={location.hash} idAgente={params.pa} />
          {
            location.hash === "#comentarios" ? (
            <Comentarios />
          ) : location.hash === "#documentos-agregados" ? (
            <Documentos />
          ) : location.hash === "#contenedores" ? (
            <Contenedores solicitud={data} naviera={data.naviera} />
          ) : location.hash === "#registro-de-tiempos" ? (
            <RegistroTiempos idSolicitud={data.id} />
          ) : location.hash === "#demoras" ? (
            <Demoras 
            idSolicitud={data.id} 
            totalDemoras={data?.total_demoras_contenedores} 
            setQuery={setQuery} 
            query={query}  
            />
          ) : null
          }
        </div>
        <ModalEditSolicitud 
          modalIsOpen={modalIsOpen} 
          closeModal={closeModal}
          idSolicitudEdit={idSolicitudEdit}
        />
    </div>
  );
};

export default AdministradorOperacion;
